import { useFilterOptions } from '../../../../utils/list-filters/use-filter-options';
import { TransformedContact } from './types';

const getName = (item: TransformedContact) => item.name;

/**
 * Custom hook to generate filter options for contacts based on their names
 * @param allData - The full list of contacts to derive filter options from
 * @returns An array of filter options for the contacts
 */
export const useContactOptions = (allData: TransformedContact[]) =>
  useFilterOptions(allData, getName);
